export default class AdminPolicy {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPermissionsEndpoint}/policy`, payload)
  }

  update(policy_id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPermissionsEndpoint}/policy/${policy_id}`, payload)
  }

  fetch(policy_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/policy/${policy_id}`)
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/policy`, { params })
  }

  delete(policy_id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminPermissionsEndpoint}/policy/${policy_id}`)
  }
}
